module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5r9r3r-49bbd27bbb39a284f284cbee77a4a9d3.svg";